import { FC } from 'react';
import { OpenInNew } from '@clds/icon';
import { DropdownMenuItemWithLink } from './DropdownMenuItemWithLink';
import { DropdownMenuItemWithLinkProps } from './DropdownMenuItem.types';

export const DropdownMenuItemInNewTab: FC<DropdownMenuItemWithLinkProps> = ({ children, analyticsMessage, ...props }) => (
  <DropdownMenuItemWithLink analyticsMessage={analyticsMessage} rightSlot={<OpenInNew size="sm" />} target="_blank" rel="noopener noreferrer" {...props}>
    {children}
  </DropdownMenuItemWithLink>
);
